import * as React from 'react';
import Tooltip from '../Tooltip';
import { validators } from '../../../utils/ehrValidators';
import { BlurEvent } from '../../../utils/customInterface';

interface Props {
    onChange: (value: string, field: string) => void;
    field: string;
    label: string;
    value: string;
    id: string;
    rules?: Object;
    extendClass?: Array<string>;
    disabled?: boolean;
    triggerCheckError?: boolean;
    triggerClearError?: boolean;
}

interface State {
    errors: Array<string>;
}

class SelectMenuWithFreeText extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            errors: new Array<string>()
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        const { rules, triggerCheckError, triggerClearError } = this.props;
        if (triggerCheckError !== nextProps.triggerCheckError) {
            let result = new Array<string>();
            if (rules) {
                Object.keys(rules).forEach(rule => {
                    const error = validators(rule, rules[rule], nextProps.value);
                    if (error.length > 0) {
                        result.push(error);
                    }
                });
            }

            if (result.length !== 0) {
                this.setState({
                    errors: result
                });
            }
        }
        if (triggerClearError !== nextProps.triggerClearError) {
            this.setState({
                errors: new Array<string>()
            });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.onChange(e.target.value, this.props.field);
    }

    handleBlur = (e: BlurEvent<HTMLInputElement>): void => {
        const { rules } = this.props;
        if (rules) {
            let result = new Array<string>();
            Object.keys(rules).forEach(rule => {
                const error = validators(rule, rules[rule], e.target.value);
                if (error.length > 0) {
                    result.push(error);
                }
            });
            this.setState({
                errors: result
            });
        }
    }

    handleFocus = (): void => {
        this.setState({
            errors: new Array<string>()
        });
    }

    render(): JSX.Element {
        const { extendClass, value, children, label, id, disabled } = this.props;
        const { errors } = this.state;
        const additionalClass = extendClass ? extendClass : ['', ''];

        return (
            <Tooltip
                wrapper="div"
                // wrap="div"
                title={errors.length > 0 ? label + errors.join(',') : ''}
                className={(errors.length > 0 ? 'has-error' : '') + (additionalClass[0] && (' ' + additionalClass[0]))}
                isValidation={true}
            >
                <input
                    type="text"
                    list={'SelectWithText_' + id}
                    className={'form-control custom-select' + (additionalClass[1] && (' ' + additionalClass[1]))}
                    value={value ? value : ''}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    disabled={disabled}
                />
                <datalist id={'SelectWithText_' + id}>
                    {children}
                </datalist>

                {/* <select
                    {...id ? { id: id } : {}}
                    className={'form-control custom-select' + (additionalClass[1] && (' ' + additionalClass[1]))}
                    value={value ? value : ''}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    disabled={disabled}
                >
                    {children}
                </select> */}
            </Tooltip>
        );
    }
}

export default SelectMenuWithFreeText;


// WEBPACK FOOTER //
// ./src/components/shared/SelectMenuWithFreeText/SelectMenuWithFreeText.tsx